module.exports = __webpack_public_path__ + "static/media/railofy_green_tick.57ff3bad.webp";